import React from 'react';
import { useNavigate } from 'react-router-dom';
import Accordion from '../components/Accordion';
// import CustomerService from '../components/CustomerService';
import AccountMainLayout from '../Layout/AccountMainLayout';

const Support = () => {
  const navigate = useNavigate();

  return (
    <>
      <AccountMainLayout>
        <div className="box-card-price">
          <div className="container">
            <div className="support-card">
              {/* <CustomerService
                Title="Give Us a Call:"
                Customer="Customer Service"
                Number="346-298-5017"
                EmergencyTitle="Attorney Hotline Emergency Number"
                EmergencyNumber="346-298-5017"
              /> */}
              <h3 className="heading-support full-support-card">Support</h3>
              <div className="first-card-price border-card-support">
                <div className="service">
                  <h3>Customer Service</h3>
                  <p>
                    <strong>
                      <a href="tel:346-298-5017">346-298-5017</a>
                    </strong>
                  </p>
                  <p>
                    <small>Mon–Fri · 9am to 6pm</small>
                  </p>
                </div>
              </div>
              <div className="first-card-price ">
                <div className="service">
                  <h3>General</h3>
                  <p>
                    <strong>
                      <a href="mailto:info@mycalibercard.com">
                        info@mycalibercard.com
                      </a>
                    </strong>
                  </p>
                  <p>
                    <small>We respond within 24 hours</small>
                  </p>
                </div>
              </div>
              <div className="contact-support-btn full-support-card">
                <button
                  className="button-golden border-golden my-0"
                  type="button"
                  onClick={() => navigate('/contact-us')}
                >
                  <img src="../images/massage-icon.svg" alt="" />
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        </div>
        <Accordion heading="LOOKING FOR INFORMATION?" />
      </AccountMainLayout>
    </>
  );
};

export default Support;
